import { Conditional } from '../../../../../../common';
import { searchLocation } from '../../../../../../common/store-contact-info/utils';
import cx from 'classnames';
import styles from '../../../../VisionLink.module.scss';
import { LocationMapDetails } from '../../../../../location-map-details';
import { AssetLocationProps } from '../../../../types';
import { VisionLinkTooltip } from '../../VisionLinkTooltip';
import { LocationUnavailable } from './LocationUnavailable';
import { useBreakpoint } from '../../../../../../../hooks';
import { PAGE_BREAKPOINTS } from '../../../../../../../constants/commonConstants';

export const AssetLocation = ({
  assetLocation,
  tooltipMessage
}: AssetLocationProps) => {
  const {
    latitude,
    longitude,
    address,
    locationUnavailable,
    locationNotFound
  } = assetLocation;
  const link = searchLocation(latitude, longitude);
  const isSM = !useBreakpoint(PAGE_BREAKPOINTS.MD);
  return (
    <div className="d-flex justify-content-between ps-4 pe-auto">
      <Conditional test={!locationUnavailable}>
        <LocationMapDetails
          link={link}
          content={address}
          contentClassName={cx('d-block ', styles['location-details'])}
          variant="label-sm"
          isEllipses={true}
        />
        <VisionLinkTooltip position="top">{tooltipMessage}</VisionLinkTooltip>
      </Conditional>
      <Conditional test={locationUnavailable}>
        <LocationUnavailable className={cx(isSM && 'text-truncate')}>
          {locationNotFound}
        </LocationUnavailable>
      </Conditional>
    </div>
  );
};
